<style lang="scss" scoped>
.izt-preferred-tag-container {
  height: 38px;
  width: fit-content;
  max-width: 100%;
  display: flex;
  position: relative;
  overflow: hidden;
  background: #FFF8F1;
  border-radius: 14px;
  .preferred-box {
    overflow: hidden;
    font-weight: 500;
    font-size: 22px;
    color: #552004;
    text-align: left;
    font-style: normal;
    background: linear-gradient( 133deg, #F2ECDE 0%, #F1EAE8 37.18%, #E0CEB7 69.75%, #EAE6E4 100%);
    border-radius: 14px;
    padding: 0 16px;
    flex-shrink: 0;
  }
  .preferred-text {
    padding: 0 16px;
    font-weight: 400;
    font-size: 22px;
    color: #844624;
    text-align: left;
    font-style: normal;
    min-width: 0;
    span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      &.carousel-leaving {
        animation: pick-carousel-slide-out 0.3s ease forwards;
      }
      &.carousel-entering {
        animation: pick-carousel-slide-in 0.3s ease forwards;
      }
    }
  }
  .preferred-box, .preferred-text {
    display: flex;
    align-items: center;
  }
}
@keyframes pick-carousel-slide-out {
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(-10px);
  }
}
@keyframes pick-carousel-slide-in {
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>

<template>
  <div :class="['izt-preferred-tag-container', className]" v-if="displayText && hideFeatLabel">
    <div class="preferred-box">
      <span>{{$t('card.优选')}}</span>
    </div>
    <div class="preferred-text">
      <span :class="animClass">{{displayText}}</span>
    </div>
  </div>
</template>

<script setup name="izt-preferred-tag">
  import { ref, watch, computed, onUnmounted } from 'vue';
  import { useConfigStore } from '@/stores/modules/config';

  defineOptions({ name: 'izt-preferred-tag' })

  const props = defineProps({
    className: {
      type: String,
      default: ''
    },
    text: {
      type: [String, Array],
      default: ''
    }
  });

  const configStore = useConfigStore();

  const displayText = ref('');
  const animClass = ref('');
  const currentIndex = ref(0);
  let carouselTimer = null;
  let switchTimer = null;

  const hideFeatLabel = computed(() => {
    return !configStore.otherConfig?.hideFeatLabel?.visible
  })

  /**
   * 停止轮播
   */
  const stopCarousel = () => {
    if (carouselTimer) {
      clearInterval(carouselTimer);
      carouselTimer = null;
    }
    if (switchTimer) {
      clearTimeout(switchTimer);
      switchTimer = null;
    }
  };

  /**
   * 启动轮播（仅在数组长度 > 1 时调用）
   */
  const startCarousel = () => {
    const list = props.text;
    if (!Array.isArray(list) || list.length < 2) return;

    // 随机初始索引
    const initialIndex = Math.floor(Math.random() * list.length);
    displayText.value = list[initialIndex];
    currentIndex.value = initialIndex;
    animClass.value = '';

    carouselTimer = setInterval(() => {
      // 旧文字滑出
      animClass.value = 'carousel-leaving';
      switchTimer = setTimeout(() => {
        let nextIndex;
        do {
          nextIndex = Math.floor(Math.random() * list.length);
        } while (nextIndex === currentIndex.value);
        currentIndex.value = nextIndex;
        displayText.value = list[nextIndex];
        // 新文字滑入
        animClass.value = 'carousel-entering';
      }, 300);
    }, 3000);
  };

  // 监听 text 变化
  watch(() => props.text, (newVal) => {
    stopCarousel();
    if (Array.isArray(newVal)) {
      if (newVal.length > 1) {
        startCarousel();
      } else if (newVal.length === 1) {
        displayText.value = newVal[0];
        animClass.value = '';
      } else {
        displayText.value = '';
        animClass.value = '';
      }
    } else if (typeof newVal === 'string') {
      displayText.value = newVal;
      animClass.value = '';
    }
  }, { immediate: true });

  onUnmounted(() => {
    stopCarousel();
  });
</script>